module.exports = __webpack_public_path__ + "img/icon-generic-generic4.b51873db.svg";